// import R3 from '@syman/burgeon-r3';
const { store, router, getKeepAliveModuleName } = R3;

export const globalStore = {
  // 1.3框架全局状态管理
  namespaced: true,
  state: {
    forcePasswordChange: false, // 是否要强制修改密码（初始用户）
    curCategoryNode: {}, // 记录商品类目-父级类目名称选中的节点及其子节点
    commodityCategoryId: '',
    relationId: '', // 记录商品SKU-商品编码
    isModalIframe: false,
    cusImgs: [],
    switchVoices: false, // 消息提示音
    baseHeight: 28, // 表格行高
    language: 'zh', // 国际化
    platformStyle: '3',
    sch_type_id: '',
    mainContentLoading: false,
    pwTips: false,
    activeTabAddr: [],
    ref: '',
    fkdialog: {
      exclude: true,
    },
    errorDialog: {
      show: false,
      type: 'error',
      title: '错误',
      errorList: [],
      hiddenButton: true,
    },
    excludedComponents: [], // 针对性缓存相应的组件

    // 促销策略数据
    dataTwoNew: {
      scheme_arr: [],
    },
    scheme_dataNew: {
      // 大类方案 商品活动(GA)，全场活动 (PA)
      program_code: 'GA',
      // 中类 discount--打折  /change--换购  /minus  /gift
      promotionType_code: 'GA12',
      // 小类（折扣、满减、特价）  all--统一打折   multiple--多种折扣    increment--递增    combine--组合
      // 小类 (买赠)  all-gift --统一赠品   all-coupon--统一送券     grade-gift--梯度赠品   grade-coupon-梯度送券
      // 小类 (换购)  all/combine   all-fprice--统一特价  all-dis--统一打折  all-minus--统一优惠   combine-fprice--组合特价  combine-dis--组合特价 combine-minus--组合特价
      detail_code: 'GA1201',
      // 组合策略，使用的值
      content: '0.9',
      rules: [
        {
          // 购买商品
          skuIds: '',
          // 条件名称
          conditionName: 'QTTY',
          // 条件类型：大于，等于。。。。
          conditionType: 'GE',
          // 条件值
          conditionValue: '',
          // 非组合策略使用的(打折、满减、特价)
          content: '',
          // 赠品、换购范围条件
          prizeItem: '',
          // 赠品、换购数量
          prizeNum: '',
        },
      ],
      limits: [
        {
          content: '0.66',
          skusId: '',
          skusNum: '',
        },
      ],
    },
    dataTwo: {
      scheme_arr: [],
    },
    scheme_data: {
      // 大类方案 商品活动(GA)，全场活动 (PA)
      program_code: 'GA',
      // 中类 discount--打折  /change--换购  /minus  /gift
      promotionType_code: 'GA12',
      // 小类（折扣、满减、特价）  all--统一打折   multiple--多种折扣    increment--递增    combine--组合
      // 小类 (买赠)  all-gift --统一赠品   all-coupon--统一送券     grade-gift--梯度赠品   grade-coupon-梯度送券
      // 小类 (换购)  all/combine   all-fprice--统一特价  all-dis--统一打折  all-minus--统一优惠   combine-fprice--组合特价  combine-dis--组合特价 combine-minus--组合特价
      detail_code: 'GA1201',
      // 组合策略，使用的值
      content: '0.9',
      rules: [
        {
          // 购买商品
          skuIds: '',
          // 条件名称
          conditionName: 'QTTY',
          // 条件类型：大于，等于。。。。
          conditionType: 'GE',
          // 条件值
          conditionValue: '',
          // 非组合策略使用的(打折、满减、特价)
          content: '',
          // 赠品、换购范围条件
          prizeItem: '',
          // 赠品、换购数量
          prizeNum: '',
        },
      ],
      limits: [
        {
          content: '0.66',
          skusId: '',
          skusNum: '',
        },
      ],
    },
    scheme_dataInit: [],
    shisuanid: '',
    // 促销二类名称和描述
    prom_type: {
      prom_type_name: '',
      prom_type_brief: '',
    },
    forginkeys: {
      columnIds: {},
      groups: {},
    },
    setCurDetail: {}, //当前详情数据
    /* --------- oms --------- */
    //订单中心 - 退货金额
    returnAmount:{
      PRO_ACTUAL_AMT:0, // 商品应退金额
      PRO_REAL_AMT:0, // 商品实退金额
      SHIP_AMT:0, //应退运费
      ADJUST_AMT:0, //调整金额
      EXCHANGE_AMT:0, //换货金额
      FINAL_ACTUAL_AMT:0, //最终应退总金额
      FINAL_REAL_AMT:0, //最终实退总金额
    },
    // 订单中心 - 退换货明细
    returnOrderChangeItem:[],
    // 订单中心 - 赔付单
    COMPENSATE: {
      detail: [],
      deleteIds: [],
      other: {},
      exCode: '',
      orderId: '',
    },
    originalOrder:'',
    extraoOrderDetails:[],
    clear:false,
    colRowNum:4, // 针对于定制界面 form表单根据屏幕变化设置个数（用于计算）
    VarTheme:'oms',
    btnTimer: '',
    addressForOrderDetail: {}
  },
  mutations: {
    abFkdialog(state, data) {
      for (const key in data) {
        state.fkdialog[key] = data[key];
      }
    },
    setForcePasswordChange(state, n) {
      state.forcePasswordChange = n;
    },
    changePlatform(state, n) {
      state.platformStyle = n;
    },
    setCurCategoryNode(state, n) {
      state.curCategoryNode = n
    },
    setCommodityCategoryId(state, n) {
      state.commodityCategoryId = n
    },
    setRelationId(state, n) {
      state.relationId = n
    },
    setIsModalIframe(state, n) {
      state.isModalIframe = n
    },
    setCusImgs(state, arr) {
      state.cusImgs = arr
    },
    switchVoices(state, payload) {
      state.switchVoices = payload
    },
    addressForOrderDetail(state, payload) {
      state.addressForOrderDetail = payload
    },
    btnTimer(state, payload) {
      state.btnTimer = payload
    },
    VarTheme(state, x){
      console.log('state, x:',state, x);
      state.VarTheme = x;
    },
    language(state, x) {
      state.language = x;
      // console.log('state.language::', x);
    },
    REDUNDANT_ORDER_ID(state, n) {
      state.REDUNDANT_ORDER_ID = n;
    },
    // 存储促销二类名称和描述
    save_prom_type(state, n) {
      state.prom_type.prom_type_name = n.prom_type_name;
      state.prom_type.prom_type_brief = n.prom_type_brief;
    },
    forginkeys(state, data) {
      state.forginkeys[data.key] = data.value;
    },
    setshisuanid(state, n) {
      state.shisuanid = n;
    },
    scheme_Index(state, index) {
      state.scheme_dataInit[index] = false;
    },
    setscheme_dataNew(state, n) {
      state.scheme_dataNew = n;
    },
    setscheme_data(state, n) {
      state.scheme_data = n;
    },
    setdataTwo(state, n) {
      state.dataTwo = n;
    },
    setCurDetail(state, paylod) {
      state.setCurDetail = paylod
    },
    fnsch_type_id(state, n) {
      state.sch_type_id = n;
    },
    scheme_dataRecover(state, n) {
      state.scheme_dataInit = n;
    },
    fndataTwo(state, data) {
      if (data.id > 0) {
        state.dataTwo = data;
      } else {
        state.dataTwoNew = data;
      }
    },
    fndataTwoNew2(state, data) {
      state.dataTwoNew.basic_info.freq_value = data;
    },
    fndataTwo2(state, data) {
      state.dataTwo.basic_info.freq_type = data;
    },
    stateChange(state, data) {
      state = Object.assign(state, data);
    },
    // 清空赋值dataTWO
    clearType(state, n) {
      state.dataTwoNew.scheme_arr = n;
    },
    // 接收切换促销策略的值
    switchDetail(state, switchTo) {
      // 促销模块
      if (switchTo.id > 0) {
        // state.dataTwo = switchTo.scheme_struct
        state.scheme_data = switchTo.scheme_struct;
      } else {
        state.scheme_dataNew = switchTo.scheme_struct;
      }
    },

    beforeSignout(state, callback) {
      // 登出
      state.logout = true;
      // if (vm.$children[0].$children.length == 0) {
      //   callback();
      // }
      this.dispatch('global/signout');
    },
    mainContentLoading(state, option) {
      state.mainContentLoading = option;
    },

    // asyncTaskDialog(state, data) {
    //   state.asyncTaskDialog.show = true;
    //   state.asyncTaskDialog.id = data.id;
    // },
    clostErrorDialog(state, data) {
      // 关闭报错提示框
      state.errorDialog.show = data;
    },
    errorDialog(state, data) {
      state.errorDialog.show = true;
      if (data.message && data.message.data && data.message.data.length > 0) {
        state.errorDialog.errorList = data.message.data;
      } else if (data.message && data.message.message) {
        state.errorDialog.errorList = data.message;
      } else {
        state.errorDialog.errorList = data;
      }

      if (data.type) {
        state.errorDialog.type = data.type;
      } else {
        state.errorDialog.type = 'error';
      }
      state.errorDialog.title = data.type == 'warning' ? $it('com.warning') : '错误';

      if (data.title) {
        state.errorDialog.title = data.title;
      }

      if (data.hiddenButton != undefined) {
        state.errorDialog.hiddenButton = data.hiddenButton;
      }
    },
    errorDialogClose(state) {
      state.errorDialog.show = false;
    },
    slidemenu(state) {
      state.sliderbar.isopen = !state.sliderbar.isopen;
    },
    // switchActiveTab(state, tab) {
    //   const selectTabs = state.selectedTabs;
    //   for (const index in selectTabs) {
    //     if (selectTabs[index].type === tab.type && selectTabs[index].name === tab.name && selectTabs[index].id == tab.id) {
    //       // state.selectedTabs.splice(index, 1);
    //       state.activeTab = state.selectedTabs[index];
    //       break;
    //     }
    //   }

    //   if (tab.type === 'singleView' || tab.type === 'singleObject') {
    //     const component = `${tab.type}_${tab.name}_${tab.id}`;
    //     const index = state.excludedComponents.indexOf(component);
    //     if (index > -1) {
    //       state.excludedComponents.splice(index, 1);
    //     }
    //   }
    // },
    // deleteAllTabs(state, tab) {
    //   state.selectedTabs = [];
    //   state.activeTab = {
    //     id: '',
    //     label: '',
    //     name: '',
    //     addr: []
    //   };
    //   route.push('/');
    // },

    // saveRefs(state, ref) {
    //   state.ref = ref;
    // },
    // favoriteList(state, list) {
    //   state.favorite.list = list;
    // },
    updateFavoriteList(state, list) {
      state.favoriteList = list.reverse();
    },
    // updateHistoryList(state, list) {
    //   state.historyList = list.reverse();
    // },
    // deleteExcludedComponents(state, tab) {
    //   let component = null;
    //   component = `${tab.type}_${tab.name}_${tab.id}`;
    //   const index = state.excludedComponents.indexOf(component);

    //   if (index > -1) {
    //     state.excludedComponents.splice(index, 1);
    //   }
    // },
    // addExcludedComponents(state, tab) {
    //   let component = null;
    //   component = `${tab.type}_${tab.name}_${tab.id}`;
    //   if (state.excludedComponents.indexOf(component) === -1) {
    //     state.excludedComponents.push(component);
    //   }
    // },

    /**
     * 当前页跳转
     * @param state
     * @param tab
     * {
     *    back: 是否为返回
     *    id
     *    type: '' 类型: table, singleView, singleObject, action, rpt...
     *    name: '' 文件名称: tablename(表名), 配置文件名
     *    label: '' tab 名称
     *    query:{} url search
     * }
     * @constructor
     */
    TabHref(state, tab) {
      if (tab.type === 'singleView' || tab.type === 'singleObject') {
        // 暂不处理
      } else {
        let url = '';
        if (tab.query && Object.keys(tab.query).length > 0) {
          // 有传参时
          // const url = '/CUSTOMIZED/promotion/-1?id=-1&tabTitle=新增促销活动';
          url = `/CUSTOMIZED/${tab.name.toUpperCase()}/${tab.id}?`;
          const param = [];

          for (const q in tab.query) {
            if (tab.query.hasOwnProperty(q)) {
              param.push(`${q}=${tab.query[q]}`);
            }
          }
          url += param.join('&');
        } else {
          // 无传参
          const type = 'C';
          const data = {
            type,
            label: tab.label,
            customizedModuleName: tab.name,
            customizedModuleId: tab.id,
          };
          store.commit('global/tabOpen', data);
        }
        const type = 'C';
        const data = {
          type,
          label: tab.label,
          url,
          customizedModuleName: tab.name,
          customizedModuleId: tab.id,
        };
        store.commit('global/tabOpen', data);
      }
      // 在当前tab打开新界面
    },
    /**
     * 打开新tab页
     * @param state
     * @param tab
     * @constructor
     */
    TabOpen(state, tab) {
      // tab.name:自定义界面name
      // tab.id:自定义界面ID
      // tab.label:自定义界面label
      if (tab.type === 'singleView' || tab.type === 'singleObject') {
        // 暂不处理
      } else {
        let url = '';
        if (tab.query && Object.keys(tab.query).length > 0) {
          // 有传参时
          // const url = '/CUSTOMIZED/promotion/-1?id=-1&tabTitle=新增促销活动';
          url = `/CUSTOMIZED/${tab.name.toUpperCase()}/${tab.id}?`;
          const param = [];

          for (const q in tab.query) {
            if (tab.query.hasOwnProperty(q)) {
              param.push(`${q}=${tab.query[q]}`);
            }
          }
          url += param.join('&');
        } else {
          // 无传参
          const type = 'C';
          const data = {
            type,
            label: tab.label,
            customizedModuleName: tab.name,
            customizedModuleId: tab.id,
          };
          store.commit('global/tabOpen', data);
        }
        const type = 'C';
        const data = {
          type,
          label: tab.label,
          url,
          customizedModuleName: tab.name,
          customizedModuleId: tab.id,
        };
        store.commit('global/tabOpen', data);
      }
    },
    /**
     * 关闭当前Tab页
     * @param state
     * @param nextTab 下一个选中的tab
     * {
     *    id
     *    type: '' 类型: table, singleView, singleObject, action, rpt...
     *    name: '' 文件名称: tablename(表名), 配置文件名
     *    label: '' tab 名称
     *    path:
     *    url:
     *    query:{} url search
     * }
     * @constructor
     */
    TabClose(state, nextTab) {
      const currentRoute = this.state.global.activeTab.routeFullPath;
      const keepAliveModuleName = getKeepAliveModuleName(router.currentRoute);
      this.commit('global/tabCloseAppoint', { routeFullPath: currentRoute, keepAliveModuleName, tableName: router.currentRoute.params.customizedModuleName });

      const type = 'C';
      const nextTabParame = {
        type,
        label: nextTab.label,
        customizedModuleName: nextTab.name,
        customizedModuleId: nextTab.id,
      };
      this.commit('global/tabOpen', nextTabParame);
    },
     /* --------- oms --------- */
    //订单中心
    returnAmount(state, n){
      // console.log(state.returnAmount,n);
      let ks = Object.keys(state.returnAmount);
      ks.forEach((k) => n[k] && (state.returnAmount[k] = n[k]));
    },
    // 编辑 退换货
    returnOrderChangeItem(state,n){
      state.returnOrderChangeItem = n;
      // console.log(state.returnOrderChangeItem,n);
    },
    COMPENSATE(state, n) {
      // console.log('state::',n);
      let obj = JSON.parse(JSON.stringify(state.COMPENSATE));
      let ks = Object.keys(n);
      ks.forEach((k) => obj[k] = n[k]);
      state.COMPENSATE = obj; // 改变引用
    },
    originalOrder(state,n){
      // console.log(state,n);
      state.originalOrder = n
    },
    extraoOrderDetails(state,n){
      state.extraoOrderDetails = n;
    },
    clear(state,n){
      state.clear = n;
    },
    colRowNum(state,n){
      state.colRowNum = n
    },
    /**
     * 删除指定tab
     * @param state
     * @param tab
     * @constructor
     */
    // TabCloseAppoint(state, tab) {
    //   const activeTab = state.activeTab;
    //   const selectTabs = state.selectedTabs;
    //   for (const index in selectTabs) {
    //     if (selectTabs[index].type === tab.type && selectTabs[index].name === tab.name && selectTabs[index].id == tab.id) {
    //       state.selectedTabs.splice(index, 1);
    //       break;
    //     }
    //   }
    //   if (tab.type === activeTab.type && tab.name === activeTab.name && tab.id == activeTab.id) {
    //     if (state.selectedTabs.length > 0) {
    //       state.activeTab = state.selectedTabs[state.selectedTabs.length - 1];
    //       route.push({
    //         path: state.activeTab.path
    //       });
    //     } else {
    //       state.activeTab = {
    //         id: '',
    //         label: '',
    //         name: '',
    //         addr: []
    //       };
    //       state.selectedTabs = [];
    //       route.push('/');
    //     }
    //   }
    // },
  },
  actions: {
    /**
     *
     * @param {*} context
     * @param {*} file 文件
     */
    downloadFile(context, file) {
      file = JSON.parse(file);
      var eleLink = document.createElement('a');
      eleLink.download = 'download';
      eleLink.style.display = 'none';
      // var blob = new Blob([content]);
      eleLink.href = file[0].url;
      document.body.appendChild(eleLink);
      eleLink.click();
      document.body.removeChild(eleLink); //解决下载会打开新页面的问题
      // location.href = file[0].url;
    },
    // 定时异步任务判断
    /**
     * {commit, state, dispatch}
     * @param context
     * @param task 任务相关信息（id）
     *
     */
    timingCalcAsyncTask(context, task) {
      let times = 10; //循环的次数
      let index = 0; //当前次数
      let timer = 0; //定时器

      context.commit('mainContentLoading', true);

      timer = setInterval(function () {
        index++;
        if (index > times) {
          clearInterval(timer);
        } else {
          //请求单对象数据
          const fromdata = new FormData();
          fromdata.append('table', 'CP_C_TASK');
          fromdata.append('objid', task.id);
          R3.network.post('/p/cs/getObject', fromdata).then((res) => {
            if (res.data.code === 0) {
              let result = res.data.data;
              let fields = result.addcolums[0].childs;
              let file = '',
                resultMsg = '';
              for (let field of fields) {
                if (field.colname === 'TASKSTATE') {
                  if (field.valuedata === '1') {
                    //执行中
                    if (index === times) {
                      context.commit('mainContentLoading', false);
                      // context.commit('asyncTaskDialog', task);
                      clearInterval(timer);
                    }
                    return;
                  } else {
                    clearInterval(timer);
                  }
                } else if (field.colname === 'URL') {
                  file = field.valuedata;
                } else if (field.colname === 'CONTENT') {
                  resultMsg = field.valuedata;
                }
              }
              //将当前记录标记为已读记录
              const fromdata = new FormData();
              fromdata.append('id', task.id);
              R3.network.post('/p/cs/ignoreMsg', fromdata).then((res) => {
                context.commit('mainContentLoading', false);
                if (resultMsg.indexOf('{') >= 0) {
                  resultMsg = JSON.parse(resultMsg);
                  if (resultMsg.code == 0) {
                    if (file) {
                      context.dispatch('downloadFile', file);
                    }
                  } else {
                    let errorList = [];
                    if (file) {
                      file = JSON.parse(file);
                      errorList.push({ message: `<a href="${file[0].url}" download="download" style="color: #0F8EE9">${resultMsg.message}（下载报错信息）</a>` });
                    } else {
                      errorList.push({ message: resultMsg.message });
                    }

                    if (resultMsg.data !== undefined && resultMsg.data.length > 0) {
                      for (let msg of resultMsg.data) {
                        if (msg.hasOwnProperty('rowIndex')) {
                          errorList.push({ message: '第' + msg.rowIndex + '条记录报错：' + msg.message });
                        } else {
                          errorList.push({ message: msg.message });
                        }
                      }
                    }
                    context.commit('errorDialog', {
                      message: {
                        data: errorList,
                      },
                    });
                  }
                } else {
                  if (file) {
                    context.dispatch('downloadFile', file);
                  } else {
                    vm.$Message.success(resultMsg);
                  }
                }
              });
            }
          });
        }
      }, 3 * 1000);
    },
  },
  modules: { },
};
export default globalStore;
